module.exports = __webpack_public_path__ + "img/lead-05z.6c073e03.png";